export default __webpack_public_path__ + "static/media/IMG_085.7db11286.jpg";